import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './pages/home/Home';
import Steps from "./pages/home/components/Steps"

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home/> } />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
